
function decode() {
    const authToken = window.sessionStorage.getItem('auth');
    if(!authToken) return undefined;
    const { accessToken, refreshToken } = JSON.parse(atob(authToken));
    const payload = accessToken ? JSON.parse(atob(accessToken.split('.')[1])) : undefined;
    return { accessToken, refreshToken, payload };
}

export default { ...decode(), decode }